var menuslidetoggleInit = function (buttonObj, slideObj, nearestObj, nearestbuttonObj ) {

    buttonObj.on("click", function (evt) {

        evt.preventDefault();   
        slideObj.slideToggle();
        slideObj.toggleClass('open');
        buttonObj.toggleClass('active');
        buttonObj.attr('aria-expanded', function (i, attr) {
            return attr == 'true' ? 'false' : 'true'
        });
                
        if (nearestObj.hasClass("open")) {

            nearestObj.slideUp().removeClass("open");
            nearestbuttonObj.removeClass("active");
        }

        if ($(this).hasClass("m-searchbutton")) {

            if ($(this).hasClass("active")) {

                $('#keyword').trigger('focus');
                $('ul.m-accountaccess a').attr("tabindex", -1);

            }

            else {
                $('ul.m-accountaccess a').attr("tabindex", 0);
            }

        }
        


    });

    // hide menu after user tabs away
    $('ul#menu li a').on('focusin', function () {
        $(this).addClass('focus');
    });

    $('ul#menu li a').on('focusout', function () {
        $(this).removeClass('focus');
    });

    $('ul#menu li:last-child a').on('keydown', function (e) {
        if (window.innerWidth < 992) {
            if (e.which == 9 && e.shiftKey) {
                // do nothing
            } else if (e.which == 9) {
                nearestObj.slideUp().removeClass("open");
                nearestbuttonObj.removeClass("active");
            }

        }
    });


}


